import { render, staticRenderFns } from "./29.vue?vue&type=template&id=685ccd51&scoped=true&"
var script = {}
import style0 from "./29.vue?vue&type=style&index=0&id=685ccd51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685ccd51",
  null
  
)

export default component.exports